export const chartTheme = {
  grid:         "#1F2937",
  axis:         "#64748B",
  tooltipBg:    "#111827",
  tooltipBorder:"#334155",
  primary:      "#6366F1",
};
